import { ColorSchemeProvider, MantineProvider } from "@mantine/core";
import { IconSun, IconMoon } from "@tabler/icons-react";
import { useEffect, useState } from "react";

const THEME_KEY = "mineralis-theme";

export function ThemeProvider({ children }) {
  const [colorScheme, setColorScheme] = useState(
    localStorage.getItem(THEME_KEY) || "light"
  );

  const toggleColorScheme = (value) => {
    const nextColorScheme = value || (colorScheme === "dark" ? "light" : "dark");
    setColorScheme(nextColorScheme);
    localStorage.setItem(THEME_KEY, nextColorScheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem(THEME_KEY);
    if (savedTheme) {
      setColorScheme(savedTheme);
    }
  }, []);

  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
      <MantineProvider
        theme={{
          colorScheme,
          colors: {
            dark: [
              "#C1C2C5",
              "#A6A7AB",
              "#909296",
              "#5C5F66",
              "#373A40",
              "#2C2E33",
              "#25262B",
              "#1A1B1E",
              "#141517",
              "#101113",
            ],
          },
        }}
        withGlobalStyles
        withNormalizeCSS
      >
        {children}
      </MantineProvider>
    </ColorSchemeProvider>
  );
}

export const SunIcon = IconSun;
export const MoonIcon = IconMoon;
